/**
 * Returns the diff of the current time and the startTime in milliseconds
 * Performance.now() is more precise that Date.now().
 * @see https://stackoverflow.com/questions/30795525/performance-now-vs-date-now
 */
const getElapsedTimeMs = (startTime: number) => {
  const endTime = performance.now();

  // In milliseconds
  return endTime - startTime;
};

export default getElapsedTimeMs;
